import { OrderPredicateAPI } from "@dashboard/discounts/types";
import { DecimalFilterInput } from "@dashboard/graphql";

import { Condition } from "../Condition";
import { getConditionType, getConditionValue } from "../helpers";
import { ORDER_ITEM_CONDITIONS } from "./constants";

type OrderConditionFilter = DecimalFilterInput | { oneOf?: string[] | null };

export const prepareOrderConditions = (
  orderPredicate: OrderPredicateAPI["discountedObjectPredicate"],
  labels: Record<string, string> = {},
): Condition[] => {
  if (!orderPredicate) {
    return [];
  }

  if (Array.isArray(orderPredicate)) {
    return orderPredicate.flatMap(predicate =>
      prepareOrderConditions(predicate, labels),
    );
  }

  return Object.entries(orderPredicate)
    .flatMap(([id, value]) => {
      if (["OR", "AND"].includes(id)) {
        return prepareOrderConditions(
          value as OrderPredicateAPI["discountedObjectPredicate"],
          labels,
        );
      }

      return toCondition(id, value as OrderConditionFilter, labels);
    })
    .filter(Boolean);
};

function toCondition(
  id: string,
  filter: OrderConditionFilter,
  labels: Record<string, string>,
): Condition {
  // Product and variant conditions are stored as { oneOf: [ids] }
  if (ORDER_ITEM_CONDITIONS.includes(id) && Array.isArray(filter.oneOf)) {
    return {
      id,
      type: "is",
      value: filter.oneOf.map(optionId => ({
        label: labels[optionId] || optionId,
        value: optionId,
      })),
    };
  }

  return {
    id,
    type: getConditionType(filter as DecimalFilterInput),
    value: getConditionValue(filter as DecimalFilterInput),
  };
}
